import React from "react";
import { Table, Button, Space, Tag, Spin } from "antd";
import { EyeOutlined, SnippetsFilled } from "@ant-design/icons";
import dateFormat from "dateformat";
import { getSpecificInvoiceByInvoiceNumber } from "../../../../actions/invoiceItem";

const OrdersTable = ({
    data,
    loading,
    pagination,
    filters,
    onTableChange,
    onViewDetails,
    onOrderClick,
}) => {
    const formatter = new Intl.NumberFormat("en-IN");
    const showConfirmedBilling = data && data.some(item => item.status === "Ecommerce Confirm");

    const ConfirmedBillCell = ({ invoiceNumber }) => {
        const [bill, setBill] = React.useState(null);
        const [loading, setLoading] = React.useState(false);


        React.useEffect(() => {
            if (invoiceNumber) {
                setLoading(true);
                getSpecificInvoiceByInvoiceNumber(invoiceNumber).then((res) => {
                    if (res) {
                        setBill(res.bill);
                    }
                    setLoading(false);
                });
            }
        }, [invoiceNumber]);

        if (loading) return <Spin size="small" />;
        return bill !== null ? `${formatter.format(bill)}` : "-";
    };

    const columns = [
        {
            title: "SL.",
            dataIndex: "index",
            key: "index",
            render: (text, record, index) => index + 1,
        },
        {
            title: "Order",
            dataIndex: "order_number",
            key: "order_number",
        },
        {
            title: "Name",
            dataIndex: "customer_name",
            key: "customer_name",
        },
        {
            title: "Phone",
            dataIndex: "customer_phone",
            key: "customer_phone",
            render: (phone) => (
                <Space>
                    <span>{phone}</span>
                </Space>
            ),
        },
        {
            title: "Initial Bill",
            dataIndex: "total_bill",
            key: "total_bill",
            render: (amount) => `${formatter.format(amount)}`,
        },
        ...(showConfirmedBilling
            ? [
                {
                    title: "Confirm Bill",
                    key: "confirmed_billing",
                    render: (_, record) => {
                        if (record.status === "Ecommerce Confirm") {
                            return <ConfirmedBillCell invoiceNumber={record.invoice_number} />;
                        }
                        return <Tag color="default">Not Confirmed</Tag>;
                    },
                },
            ]
            : []),
        {
            title: "Status",
            dataIndex: "status",
            key: "status",
            render: (status) => {
                let color = "default";
                if (status === "Ecommerce Pending") color = "orange";
                else if (status === "Ecommerce Confirm") color = "green";
                else if (status === "Ecommerce Rejected") color = "red";
                return <Tag color={color}>{status}</Tag>;
            },
        },
        {
            title: "Order Status",
            dataIndex: "order_status",
            key: "order_status",
        },
        {
            title: "Created",
            dataIndex: "created_at",
            key: "created_at",
            render: (date) => dateFormat(date, "dd-mm-yyyy hh:MM TT"),
        },
        // {
        //     title: "Updated",
        //     dataIndex: "updated_at",
        //     key: "updated_at",
        //     render: (date) => dateFormat(date, "dd-mm-yyyy hh:MM TT"),
        // },
        {
            title: "Action",
            key: "action",
            fixed: "right",
            render: (_, record) => (
                <Space size="small">
                    <Button type="primary" icon={<EyeOutlined />} onClick={() => onViewDetails(record)}>
                        View
                    </Button>
                    <Button
                        type="default"
                        icon={<SnippetsFilled />}
                        onClick={() => onOrderClick(record)}
                        disabled={!record.confirm}
                        style={{
                            opacity: record.confirm ? 1 : 0.6,
                            cursor: record.confirm ? "pointer" : "not-allowed",
                        }}
                    >
                        Order
                    </Button>
                </Space>
            ),
        },
    ];

    return (
        <Table
            columns={columns}
            dataSource={data}
            loading={loading}
            rowKey="id"
            pagination={{
                ...pagination,
                showSizeChanger: true,
                showTotal: (total) => `Total ${total} orders`,
                pageSizeOptions: ["10", "20", "50", "100"],
            }}
            onChange={onTableChange}
        />
    );
};

export default OrdersTable;